import { jsx } from '@emotion/core';
import { BORDER_RADIUS, COLORS, PADDING } from '../../constants';
import { facepaintMediaQueries } from '../shared';
var styles = facepaintMediaQueries({
  border: "solid 1px " + COLORS.grays.cardBorder,
  borderLeftWidth: [0, 1],
  borderRightWidth: [0, 1],
  borderRadius: [0, BORDER_RADIUS.medium],
  padding: [PADDING.tiny, PADDING["default"]],
  background: COLORS.white
});
export var Card = function Card(_a) {
  var children = _a.children,
      className = _a.className;
  return jsx("div", {
    css: styles,
    className: className
  }, children);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Card/index.js
// module id = 195
// module chunks = 0